import { getPlannerElementSetPropertyValue } from "../FieldUtils";

export const getCardPlannerElementSetProperties = ({
  plannerElementSetConfig = [],
}) => {
  const allowDescription = getPlannerElementSetPropertyValue({
    plannerElementSetConfig,
    propertyName: "allowDescription",
  });

  const allowIcon = getPlannerElementSetPropertyValue({
    plannerElementSetConfig,
    propertyName: "allowIcon",
  });

  const selectionType = getPlannerElementSetPropertyValue({
    plannerElementSetConfig,
    propertyName: "selectionType",
  });

  return {
    allowDescription,
    allowIcon,
    selectionType,
  };
};
